import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { normalizeReportShareContext } from './reportShareProtocol';

const ReportingShareContext = createContext({
  publishShareContext: () => {},
  clearShareContext: () => {},
});

export function ReportingShareProvider({ onContextChange, onClear, children }) {
  const publishShareContext = useCallback(
    (context) => {
      const normalized = normalizeReportShareContext(context);
      if (normalized) onContextChange?.(normalized);
    },
    [onContextChange],
  );

  const clearShareContext = useCallback(() => {
    onClear?.();
  }, [onClear]);

  const value = useMemo(
    () => ({ publishShareContext, clearShareContext }),
    [publishShareContext, clearShareContext],
  );

  return (
    <ReportingShareContext.Provider value={value}>
      {children}
    </ReportingShareContext.Provider>
  );
}

export function useReportingSharePublisher() {
  return useContext(ReportingShareContext);
}
